import { useOrderFlowProperty } from 'utils/analytics/useOrderFlowProperty'
import { useBkbnSearchParams } from 'utils/hooks/useBkbnSearchParams'

/**
 * Stamps the purchase flow's events with the property they are about (ISSUE-3932): the CRM's objectReferenceId
 * from the URL, and our realtyId — the resolved property once known, the URL's only while its lookup is pending,
 * so a failed lookup does not leave a property the order is not for on later events (the purchase among them).
 * Events before the lookup resolves (the embed URL carries no realtyId) join on objectReferenceId.
 */
export const useOrderFlowPropertyTracking = (realEstatePropertyId: string | null, isPropertyLookupPending: boolean) => {
  const params = useBkbnSearchParams()

  useOrderFlowProperty({
    objectReferenceId: params.get('objectReferenceId'),
    realtyId: realEstatePropertyId ?? (isPropertyLookupPending ? params.get('realtyId') : null),
  })
}
